import {useEffect} from 'react';
import {message} from 'antd';
import {useTranslation} from 'react-i18next';
import api from '../api';
import {useAssetGroupDispatch, useAssetGroupState} from '../../contexts/AssetGroupContext';
import {useLoadedAssetsState} from '../../contexts/LoadedAssetsContext';
import {useFilters} from '../helpers/useFilters';

// Keep request decisions current even while the sidebar or its workflow panel is closed.
export default function AccessRequestWorkflowLoader() {
    const {currentAssetGroup, currentWorkflowStep} = useAssetGroupState();
    const dispatch = useAssetGroupDispatch();
    const {reloads} = useLoadedAssetsState();
    const {filters, setFilters} = useFilters();
    const {t} = useTranslation();
    const requestId = currentAssetGroup.access_request_id;
    const groupId = currentAssetGroup.asset_group_id;
    const stepId = currentWorkflowStep?.asset_group_id === groupId &&
        currentAssetGroup.workflow_steps?.some(step => step.id === currentWorkflowStep?.id) ? currentWorkflowStep?.id : null;

    useEffect(() => {
        if (!stepId) return;
        let active = true;
        api(`/api/workflow_steps/${stepId}`).then(({data}) => {
            if (active && data.id === stepId && data.asset_group_id === groupId && data.asset_group?.access_request_id === requestId) {
                dispatch({type: 'setCurrentWorkflowStep', step: data});
            }
        }).catch(() => {
            if (active) message.error(t('error-loading-approval-counts', 'Unable to load approval counts. Please refresh and try again.'));
        });
        return () => { active = false; };
    }, [requestId, groupId, stepId, reloads, dispatch]);

    useEffect(() => {
        if (stepId && !filters.workflow_state?.includes('pending')) setFilters(false, {workflow_state: 'pending'});
        // Initialize once per request/step; later user filter changes and count reloads stay intact.
    }, [requestId, groupId, stepId]);

    return null;
}
